/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { transferFeeComparisonMessages } from '../messages/transfer-fee-comparison';
export const TransferFeeComparisonTranslations = merge(undefined, commonMessages, transferFeeComparisonMessages);
